"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomBuffer = exports.getTimestamp = void 0;
var crypto_1 = require("crypto");
var getTimestamp = function () { return Math.floor(Date.now() / 1000); };
exports.getTimestamp = getTimestamp;
var randomBuffer = function (length) {
    if (length === void 0) { length = 32; }
    return (0, crypto_1.randomBytes)(length).toString();
};
exports.randomBuffer = randomBuffer;
